const base_url = "https://2x6pwxnrll.execute-api.us-east-1.amazonaws.com/Dev/";
// const base_url = "https://63japqerd7.execute-api.us-east-1.amazonaws.com/Dev/zone2_";
//const base_url = "https://g934ehp5bj.execute-api.us-east-1.amazonaws.com/demo/demo_";

const base_url2 = "https://tokcfhkksh.execute-api.us-east-1.amazonaws.com/Dev/";
// const base_url2 = "https://63japqerd7.execute-api.us-east-1.amazonaws.com/Dev/zone2_";
//const base_url2 = "https://g934ehp5bj.execute-api.us-east-1.amazonaws.com/demo/demo_";

const requests = {
  config_table_url: `${base_url}view_config_values`,
  config_form_url: `${base_url}manage_config_values`,
  active_fields_url: `${base_url}get_active_fields`,
  get_operator_url: `${base_url}get_operator`,
  view_rules_url: `${base_url}vcare_getrules`,
  rule_toggle_url: `${base_url}vcare_togglestate`,
  get_rule_def_url: `${base_url}vcare_getruledef`,
  save_rules_url: `${base_url}vcareui_saverules`,
  displayprocessrules_url: `${base_url}vcare_displayprocessrules`,
  ruleconsumer_url: `${base_url}vcare_ruleconsumer`,

  ruleCheckPoint_table_url: `${base_url}vcare_rulecheckpoint`,
  rulelist_table_url: `${base_url}vcare_rulelist`,
  rulecheckpointstep_url: `${base_url}vcare_rulecheckpointstep`,
  removeCheckpointstep_url: `${base_url}vcare_deletecheckpointsteps`,

  dashboard_tasklist_url: `${base_url2}dashboard_tasklist`,
  dashboard_stats: `${base_url2}vcareui_dashboardstats`,
};

export default requests;
